import { useTranslation } from 'next-i18next';
import React from 'react';
import { MessageType, MessagingAttendee, MessagingFile } from '../../../../../interfaces/interfaces';
import { formatUTCDate } from '../../../../../services/helper';
import AttendeeAvatar from '../AttendeeAvatar';
import { CallEventChip } from './AttendeeCall/CallEventChip';
import { MessageFiles } from './MessageFiles';
import { MessagingVcard } from './vcard/MessagingVcard';

interface MessageProps {
  isOwn: boolean;
  messageId?: string;
  message?: string;
  files?: MessagingFile[];
  messageType: MessageType;
  date: Date;
  ended?: Date;
  attendee: MessagingAttendee;
  pending?: boolean;
  isError?: boolean;
  onResend?: () => void;
}

export const Message = (props: MessageProps) => {
  const { message, messageId, messageType, date, ended, isError = false, isOwn, pending = false, attendee, files, onResend } = props;
  const { t } = useTranslation();

  return (
    <div className={`w-full flex flex-row justify-${!isOwn ? 'start' : 'end'} `}>
      <div className="flex flex-col items-end w-full md:w-2/3">
        <div className={` group w-full flex ${!isOwn ? 'flex-row' : 'flex-row-reverse'} space-x-2 messageDiv items-center`}>
          {!isOwn && <AttendeeAvatar attendee={attendee} />}
          {!messageType ||
            (messageType === 'MESSAGE' && (
              <div
                className={`transition-all flex flex-col space-y-1 rounded-md p-2 my-1 mx-4 opacity-${!pending && !isError ? '100' : '50'}
                mr-${!pending && !isError ? '0' : '2'}`}
                style={{ backgroundColor: !isOwn ? '#69747c' : 'var(--scheme-main)', color: 'var(--buttons-main)' }}>
                <p className="break-word">{message}</p>
                <MessageFiles files={files} pending={pending} />
              </div>
            ))}
          {messageType === 'CALL' && <CallEventChip />}

          {messageType === 'VCARD' && <MessagingVcard attendee={attendee} message={messageId} isOwn={isOwn} />}
          {date && <p className="text-slate-400 italic invisible group-hover:visible mx-14">{formatUTCDate(new Date(date), 'dd.MM.yyyy HH:mm')}</p>}
        </div>
        {isError && (
          <p className="cursor-pointer" onClick={() => onResend?.()}>
            {t('event:messaging.resend-message')}
          </p>
        )}
      </div>
    </div>
  );
};
